export default __webpack_public_path__ + "static/media/warning--bollard--g1.92dd9345.png";